"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAttachmentsForReplies = getAttachmentsForReplies;
exports.getAttachmentsForTopic = getAttachmentsForTopic;
exports.saveAttachmentsToTopic = saveAttachmentsToTopic;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var _axios = _interopRequireDefault(require("axios"));

function saveAttachmentsToTopic(_x, _x2, _x3) {
  return _saveAttachmentsToTopic.apply(this, arguments);
}

function _saveAttachmentsToTopic() {
  _saveAttachmentsToTopic = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee(privateId, contentType, attachments) {
    var maxRetries,
        attempt,
        latestError,
        _args = arguments;
    return _regenerator.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            maxRetries = _args.length > 3 && _args[3] !== undefined ? _args[3] : 3;
            attempt = 0;
            latestError = null;

          case 3:
            if (!(attempt < maxRetries)) {
              _context.next = 19;
              break;
            }

            _context.prev = 4;
            _context.next = 7;
            return _axios.default.post("/attachment/saveToTopic?id=".concat(privateId, "&contentType=").concat(contentType), {
              attachments: attachments
            });

          case 7:
            return _context.abrupt("return", _context.sent);

          case 10:
            _context.prev = 10;
            _context.t0 = _context["catch"](4);
            ++attempt;
            latestError = _context.t0; // eslint-disable-next-line no-console

            console.log("saveAttachmentsToTopic: attempt(".concat(attempt, ") failed"));
            _context.next = 17;
            return new Promise(function (resolve) {
              return setTimeout(resolve, 500);
            });

          case 17:
            _context.next = 3;
            break;

          case 19:
            throw latestError;

          case 20:
          case "end":
            return _context.stop();
        }
      }
    }, _callee, null, [[4, 10]]);
  }));
  return _saveAttachmentsToTopic.apply(this, arguments);
}

function getAttachmentsForTopic(_x4, _x5) {
  return _getAttachmentsForTopic.apply(this, arguments);
}

function _getAttachmentsForTopic() {
  _getAttachmentsForTopic = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee2(privateId, contentType) {
    var _yield$axios$post, data;

    return _regenerator.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return _axios.default.post("/attachment/getForTopic?id=".concat(privateId, "&contentType=").concat(contentType));

          case 2:
            _yield$axios$post = _context2.sent;
            data = _yield$axios$post.data;
            return _context2.abrupt("return", data.attachments);

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _getAttachmentsForTopic.apply(this, arguments);
}

function getAttachmentsForReplies(_x6) {
  return _getAttachmentsForReplies.apply(this, arguments);
}

function _getAttachmentsForReplies() {
  _getAttachmentsForReplies = (0, _asyncToGenerator2.default)( /*#__PURE__*/_regenerator.default.mark(function _callee3(privateIds) {
    var _yield$axios$get, data;

    return _regenerator.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            _context3.next = 2;
            return _axios.default.get("/attachment/getForPost?postIds=".concat(privateIds));

          case 2:
            _yield$axios$get = _context3.sent;
            data = _yield$axios$get.data;
            return _context3.abrupt("return", data);

          case 5:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
  return _getAttachmentsForReplies.apply(this, arguments);
}